"use client";

import { usePathname } from "next/navigation";
import { salonDestinations } from "./salon-destination";

export const SalonDestination = () => {
  const pathname = usePathname();
  const salonId = pathname.split("/").pop();
  const salon = salonDestinations[salonId as string];

  if (!salon) return null;

  // Générer l'URL avec les coordonnées
  const googleMapsUrlWithCoords = `https://www.google.com/maps/dir/?api=1&destination=${salon.coordinates.lat},${salon.coordinates.lng}`;

  return (
    <div className="flex flex-col items-center gap-4 px-4 pb-12">
      <h2 className="text-center text-2xl font-semibold">
        Comment venir au {salon.title} ?
      </h2>
      <div className="flex flex-col gap-3 sm:flex-row">
        <a
          href={salon.googleMapsUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="group relative inline-block overflow-hidden border border-primary px-8 py-3 text-primary transition-colors"
        >
          <span className="relative z-10 flex items-center gap-2 transition-colors group-hover:text-white">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 2C7.6 2 4 5.6 4 10c0 5 8 12 8 12s8-7 8-12c0-4.4-3.6-8-8-8zm0 11c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3z" />
            </svg>
            Voir sur Google Maps
          </span>
          <div className="absolute bottom-0 left-0 h-full w-0 bg-primary transition-all duration-300 ease-out group-hover:w-full" />
        </a>
        <a
          href={googleMapsUrlWithCoords}
          target="_blank"
          rel="noopener noreferrer"
          className="group relative inline-block overflow-hidden border border-primary px-8 py-3 text-primary transition-colors"
        >
          <span className="relative z-10 flex items-center gap-2 transition-colors group-hover:text-white">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M9 18l6-6-6-6" />
            </svg>
            Obtenir l&apos;itinéraire
          </span>
          <div className="absolute bottom-0 left-0 h-full w-0 bg-primary transition-all duration-300 ease-out group-hover:w-full" />
        </a>
      </div>
      <p className="text-center text-gray-600">
        Choisissez votre option de navigation préférée
      </p>
    </div>
  );
};
